// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_new-voucher-btn__mhIT1 {
  width: 210px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  height: 36px;
}

.styles_voucher-form__IfK3R{
  text-align: start;
}

.styles_voucher-form-grid__UxIoo{
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 26px;
}

.styles_grid-span-full__8AcZm{
  grid-column: span 2;
}`, "",{"version":3,"sources":["webpack://./src/pages/vouchers/styles/styles.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".new-voucher-btn {\n  width: 210px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  height: 36px;\n}\n\n.voucher-form{\n  text-align: start;\n}\n\n.voucher-form-grid{\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 26px;\n}\n\n.grid-span-full{\n  grid-column: span 2;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"new-voucher-btn": `styles_new-voucher-btn__mhIT1`,
	"voucher-form": `styles_voucher-form__IfK3R`,
	"voucher-form-grid": `styles_voucher-form-grid__UxIoo`,
	"grid-span-full": `styles_grid-span-full__8AcZm`
};
export default ___CSS_LOADER_EXPORT___;
